var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapMarkers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22s8-7.582 8-12a8 8 0 10-16 0c0 4.418 8 12 8 12zm0-8a4 4 0 100-8 4 4 0 000 8z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyMkMxMiAyMiAyMCAxNC40MTgzIDIwIDEwQzIwIDUuNTgxNjcgMTYuNDE4MyAyIDEyIDJDNy41ODE3MyAyIDQgNS41ODE2NyA0IDEwQzQgMTQuNDE4MyAxMiAyMiAxMiAyMlpNMTIgMTRDMTQuMjA5MiAxNCAxNiAxMi4yMDkxIDE2IDEwQzE2IDcuNzkwODkgMTQuMjA5MiA2IDEyIDZDOS43OTA4MyA2IDggNy43OTA4OSA4IDEwQzggMTIuMjA5MSA5Ljc5MDgzIDE0IDEyIDE0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgMapMarkers as ReactComponent };